import React, { useState, useEffect, useRef } from 'react';

const ColorWheel = ({ onChange }) => {
  const canvasRef = useRef(null);
  const [context, setContext] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    setContext(ctx);
  }, []);

  const handleColorChange = (event) => {
    const x = event.nativeEvent.offsetX;
    const y = event.nativeEvent.offsetY;
    const imageData = context.getImageData(x, y, 1, 1).data;
    const rgb = `rgb(${imageData[0]}, ${imageData[1]}, ${imageData[2]})`;
    onChange(rgb);
  };

  useEffect(() => {
    if (!context) return;

    const centerX = canvasRef.current.width / 2;
    const centerY = canvasRef.current.height / 2;
    const radius = centerX;

    for (let angle = 0; angle < 360; angle++) {
      const startAngle = (angle - 90) * Math.PI / 180;
      const endAngle = (angle - 89) * Math.PI / 180;
      context.beginPath();
      context.moveTo(centerX, centerY);
      context.arc(centerX, centerY, radius, startAngle, endAngle);
      context.closePath();
      context.fillStyle = `hsl(${angle}, 100%, 50%)`;
      context.fill();
    }
  }, [context]);

  return (
    <canvas
      ref={canvasRef}
      width={300}
      height={300}
      onClick={handleColorChange}
      style={{ cursor: 'pointer' }}
    ></canvas>
  );
};

export default ColorWheel;
